import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import Styles
import './scss/style.scss';
import './assets/css/remixicon.css';

// Import Routes & Layouts
import AppRoutes from './AppRoutes';
import Main from './layouts/Main';
import NotFound from "./pages/NotFound";
import publicRoutes from './routes/PublicRoutes';
import protectedRoutes from './routes/ProtectedRoutes';
import ProtectedRoute from './routes/ProtectedRoute';
import { AuthProvider } from './hooks/AuthContext';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import AuthLoader from './authLoader';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Provider store={store}>
          <AuthLoader>
            <Routes>
              {/* Public Routes */}
              {publicRoutes.map((route, index) => (
                <Route path={route.path} element={route.element} key={index} />
              ))}

              {/* Protected Routes */}
              <Route
                path="/"
                element={<ProtectedRoute />}
              >
                {protectedRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
              </Route>
            </Routes>
          </AuthLoader>
          <ToastContainer />
        </Provider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
